import { createRouter, createWebHashHistory } from 'vue-router';
import { checkIsAdmin } from '../utils/authUtils';
import { useSystemStatus } from '../composables/useSystemStatus';
import VueCookies from 'vue-cookies';
import { api, configUri, stripeKey } from '../config';
import { selectedFilter as spendingFilter, selectedPeriod as spendingPeriod, selectedAccount as spendingAccount, selectedSubCategory as spendingSubCategory, selectedSubCategoryColour as spendingSubCategoryColour, selectedMerchant as spendingMerchant, dateSelection as spendingDateSelection, } from '../components/elements/spendingAnalysisFilterState';
import Notifications from '../components/NotificationsPage.vue';
import WhatsAppCoaching from '../components/WhatsAppCoachingPage.vue';
import MoneyHubLink from '../components/MoneyHubLinkPage.vue';
import MoneyHubCallback from '../components/MoneyHubCallbackPage.vue';
import YouPage from '../components/YouPage.vue';
import AppSettingsPage from '../components/AppSettingsPage.vue';
import PersonalInformationPage from '../components/PersonalInformationPage.vue';
import AddressPage from '../components/AddressPage.vue';
import EnableWhatsApp from '../components/EnableWhatsApp.vue';
import SpendingAnalysisPage from '../components/SpendingAnalysisPage.vue';
import SpendingTreemapPage from '../components/SpendingTreemapPage.vue';
import TestPage from '../components/TestPage.vue';
import VoucherCartPage from '../components/VoucherCartPage.vue';
import AccountsPage from '../components/AccountsPage.vue';
import AccountPage from '../components/AccountPage.vue';
import TransactionDetailPage from '../components/TransactionDetailPage.vue';
import HomePage from '../components/HomePage.vue';
import ActivityPage from '../components/ActivityPage.vue';
import GuidesPage from '../components/GuidesPage.vue';
import GuidePage from '../components/GuidePage.vue';
import GuideSectionPage from '../components/GuideSectionPage.vue';
import GuideTaskPage from '../components/GuideTaskPage.vue';
import ArticlePage from '../components/ArticlePage.vue';
import VouchersShopPage from '../components/VouchersShopPage.vue';
import ShopVouchersPage from '../components/ShopVouchersPage.vue';
import VoucherCheckoutPage from '../components/VoucherCheckoutPage.vue';
import VoucherAmountPage from '../components/VoucherAmountPage.vue';
import VouchersSearchPage from '../components/VouchersSearchPage.vue';
import PaymentCompletePage from '../components/PaymentCompletePage.vue';
import LoginPage from '../components/LoginPage.vue';
import MyVouchersByMerchantPage from '../components/MyVouchersByMerchantPage.vue';
import MyVouchersForMerchantPage from '../components/MyVouchersForMerchantPage.vue';
import SavedToSpendPage from '../components/SavedToSpendPage.vue';
import MyMGMPage from '../components/MyMGMPage.vue';
import RedeemMGMPage from '../components/RedeemMGMPage.vue';
import WalletPage from '../components/WalletPage.vue';
import QuestionnairePage from '../components/QuestionnairePage.vue';
import AssetPage from '../components/AssetPage.vue';
import AssetSuccessPage from '../components/AssetSuccessPage.vue';
import BankAccountSuccessPage from '../components/BankAccountSuccessPage.vue';
import CompletedMovesPage from '../components/CompletedMovesPage.vue';
import MovesPage from '../components/MovesPage.vue';
import MovePage from '../components/MovePage.vue';
import WelcomePage from '../components/WelcomePage.vue';
import FinancialFitnessLandingPage from '../components/FinancialFitnessLandingPage.vue';
import FinancialFitnessResultsPage from '../components/FinancialFitnessResultsPage.vue';
import FinancialFitnessHistoryPage from '../components/FinancialFitnessHistoryPage.vue';
import PersonalisationLandingPage from '../components/PersonalisationLandingPage.vue';
import PersonalisationFinishPage from '../components/PersonalisationFinishPage.vue';
import BenefitsCalculatorLandingPage from '../components/BenefitsCalculatorLandingPage.vue';
import BenefitsCalculatorResultsPage from '../components/BenefitsCalculatorResultsPage.vue';
import FinancesFinishPage from '../components/FinancesFinishPage.vue';
import GetStartedPage from '../components/GetStartedPage.vue';
import AwaitEmailVerificationPage from '../components/AwaitEmailVerificationPage.vue';
import EligibilityVerifiedPage from '../components/EligibilityVerifiedPage.vue';
import InsuranceSuccessPage from '../components/InsuranceSuccessPage.vue';
import AddInsuranceMoreDetailsPage from '../components/AddInsuranceMoreDetailsPage.vue';
import PersonalDetailsPage from '../components/PersonalDetailsPage.vue';
import CreateAccountPage from '../components/CreateAccountPage.vue';
import SetPinPage from '../components/SetPinPage.vue';
import AddOfflineBankAccountPage from '../components/AddOfflineBankAccountPage.vue';
import AddInsurancePage from '../components/AddInsurancePage.vue';
import AddInvestmentPage from '../components/AddInvestmentPage.vue';
import AddPensionPage from '../components/AddPensionPage.vue';
import AddCreditPage from '../components/AddCreditPage.vue';
import AddMortgagePage from '../components/AddMortgagePage.vue';
import PolicyPage from '../components/PolicyPage.vue';
import EnableNotificationsPage from '../components/EnableNotificationsPage.vue';
import BenefitsPage from '../components/BenefitsPage.vue';
import MarketplacePage from '../components/MarketplacePage.vue';
import ProductPage from '../components/ProductPage.vue';
import RecurringPaymentsPage from '../components/RecurringPaymentsPage.vue';
import UncategorisedTransactionsPage from '../components/UncategorisedTransactionsPage.vue';
import TransactionBulkPage from '../components/TransactionBulkPage.vue';
import LinkOpenBankingAccountPage from '../components/LinkOpenBankingAccountPage.vue';
import SetupSpendingAnalysisPage from '../components/SetupSpendingAnalysisPage.vue';
import SpendingPlanPage from '../components/SpendingPlanPage.vue';
import GoalsPage from '../components/GoalsPage.vue';
import GoalPage from '../components/GoalPage.vue';
import RelinkAccountsPage from '../components/RelinkAccountsPage.vue';
import CalculatorsPage from '../components/CalculatorsPage.vue';
import LoadTestPage from '../components/LoadTestPage.vue';
import AllNotificaionsPage from '../components/AllNotificationsPage.vue';
import UnprocessedDocumentsPage from '../components/UnprocessedDocumentsPage.vue';
import DocumentsPage from '../components/DocumentsPage.vue';
import AllDocumentsPage from '../components/AllDocumentsPage.vue';
import DocumentPage from '../components/DocumentPage.vue';
import DocumentViewPage from '../components/DocumentViewPage.vue';
import PayslipsPage from '../components/PayslipsPage.vue';
import RecommendedVouchersPage from '../components/RecommendedVouchersPage.vue';
import FeaturedVouchersPage from '../components/FeaturedVouchersPage.vue';
import BoostedVouchersPage from '../components/BoostedVouchersPage.vue';
import FavoriteVouchersPage from '../components/FavoriteVouchersPage.vue';
import TopSavingsVouchersPage from '../components/TopSavingsVouchersPage.vue';
import BiggestDiscountsVouchersPage from '../components/BiggestDiscountsVouchersPage.vue';
import SpendByCustomerTagPage from '../components/SpendByCustomerTagPage.vue';
import PersonalNewsPage from '../components/PersonalNewsPage.vue';
import MyArchivedVouchersPage from '../components/MyArchivedVouchersPage.vue';
import BuyWithConfidencePage from '../components/BuyWithConfidencePage.vue';
import TrackYourSpendPage from '../components/TrackYourSpendPage.vue';
import HowItWorksVouchersPage from '../components/HowItWorksVouchersPage.vue';
import VoucherCategories from '../components/VoucherCategories.vue';
import Money from '../components/MoneyPage.vue';
import FaqsPage from '../components/FaqsPage.vue';
import AchievementsPage from '../components/AchievementsPage.vue';
import AchievementsLeaderBoardPage from '../components/AchievementsLeaderBoardPage.vue';
import LitmusTestPage from '../components/LitmusTestPage.vue';
import ChristmasQuizCompleteCorrectPage from '../components/ChristmasQuizCompleteCorrectPage.vue';
import ChristmasQuizCompleteWrongPage from '../components/ChristmasQuizCompleteWrongPage.vue';
import StoryPage from '../components/StoryPage.vue';
import Desktop from '../desktop/Desktop.vue';
import ChatPage from '../desktop/pages/ChatPage.vue';
import DesktopShopVouchersPage from '../desktop/pages/ShopVouchersPage.vue';
import DesktopTransactionsPage from '../desktop/pages/TransactionsPage.vue';
import DesktopSpendingAnalysisPage from '../desktop/pages/SpendingAnalysisPage.vue';
import DesktopSpendingPlanPage from '../desktop/pages/SpendingPlanPage.vue';
import DesktopDocumentsPage from '../desktop/pages/DocumentsPage.vue';
import Admin from '../admin/Admin.vue';
import AdminLandingPage from '../admin/pages/AdminLandingPage.vue';
import FactoidsPage from '../admin/pages/FactoidsPage.vue';
import EmployersPage from '../admin/pages/EmployersPage.vue';
import CustomersPage from '../admin/pages/CustomersPage.vue';
import CustomerUploadsPage from '../admin/pages/CustomerUploadsPage.vue';
import CDNUploadPage from '../admin/pages/CDNUploadPage.vue';
import VouchersPage from '../admin/pages/VouchersPage.vue';
import CategoriesPage from '../admin/pages/CategoriesPage.vue';
import GuideAdminPage from '../admin/pages/GuideAdminPage.vue';
import WalkthroughAdminPage from '../admin/pages/WalkthroughAdminPage.vue';
import AIChatSettingsPage from '../admin/pages/AIChatSettingsPage.vue';
import CachePage from '../admin/pages/CachePage.vue';
import SystemStatusPage from '../admin/pages/SystemStatusPage.vue';
import ProductsPage from '../admin/pages/ProductsPage.vue';
import AIChatMessagesPage from '../admin/pages/AIChatMessagesPage.vue';
import FaqPage from '../admin/pages/FaqPage.vue';
import QuizzesPage from '../admin/pages/QuizzesPage.vue';
import PolicySectionsPage from '../admin/pages/PolicySectionsPage.vue';
import BrandLogoOverridesPage from '../admin/pages/BrandLogoOverridesPage.vue';
import ReferralsPage from '../admin/pages/ReferralsPage.vue';
import QueuedDiscountActionsPage from '../admin/pages/QueuedDiscountActionsPage.vue';
import ReferralsVisualisePage from '../admin/pages/ReferralsVisualisePage.vue';
import TransactionClassificationsPage from '../admin/pages/TransactionClassificationsPage.vue';
import MerchantsPage from '../admin/pages/MerchantsPage.vue';
import AdminMovesPage from '../admin/pages/MovesPage.vue';
import ListsPage from '../admin/pages/ListsPage.vue';
import GitHistoryPage from '../admin/pages/GitHistoryPage.vue';
const router = createRouter({
    history: createWebHashHistory(),
    scrollBehavior(to, from, savedPosition) {
        // If there's a saved position (from browser back/forward), use it
        if (savedPosition) {
            return savedPosition;
        }
        // For new navigations, scroll to top
        return { top: 0 };
    },
    routes: [
        {
            path: '/', component: HomePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'home',
                backgroundImage: require('@/assets/bg/bg.png'),
                showVoucherIcon: true,
                allowBack: false,
                bounce: true,
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/welcome', component: WelcomePage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                authenticated: false,
                allowBack: false,
                bounce: true
            }
        },
        {
            path: '/activity', component: ActivityPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'activity',
                // backgroundImage: require('@/assets/bg/bg.png'),
                aiChat: "I'd like to talk about my spending analysis, savings goals and spending plans (which are budgets) in the 'Activity' screen in the money guided app. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                allowBack: false,
                bounce: true
            }
        },
        {
            path: '/getstarted', component: GetStartedPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                backgroundImage: require('@/assets/bg/hero-blurred.png'),
                authenticated: false,
                allowBack: false
            }
        },
        {
            path: '/verifyemail/:employer/:id', component: AwaitEmailVerificationPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                backgroundImage: require('@/assets/bg/hero-blurred.png'),
                authenticated: false
            }
        },
        {
            path: '/eligibilityverified', component: EligibilityVerifiedPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                authenticated: false,
                allowBack: false
            }
        },
        {
            path: '/insurancesuccess', component: InsuranceSuccessPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: false,
                backgroundColor: '#E1C6C8',
            }
        },
        {
            path: '/assetsuccess', component: AssetSuccessPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: false,
                backgroundColor: '#E1C6C8',
            }
        },
        {
            path: '/accountsuccess', component: BankAccountSuccessPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: false,
                backgroundColor: '#E1C6C8',
            }
        },
        {
            path: '/assetsuccess', component: AssetSuccessPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: false,
                backgroundColor: '#E1C6C8',
            }
        },
        {
            path: '/insurancemoredetails', component: AddInsuranceMoreDetailsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money'
            }
        },
        {
            path: '/setupspendinganalysis', component: SetupSpendingAnalysisPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: true,
                bgColor: 'white'
            }
        },
        {
            path: '/personaldetails', component: PersonalDetailsPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                backgroundColor: '#332847',
                authenticated: false,
                allowBack: false
            }
        },
        {
            path: '/linkopenbankingaccount', component: LinkOpenBankingAccountPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                backgroundColor: '#332847',
                allowBack: false
            }
        },
        {
            path: '/createaccount', component: CreateAccountPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                backgroundColor: '#332847',
                authenticated: false
            }
        },
        {
            path: '/setpin', component: SetPinPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
            }
        },
        {
            path: '/money', component: Money,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: false,
                bounce: true,
                showVoucherIcon: true,
                aiChat: false,
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/faqs', component: FaqsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                allowBack: true,
                bounce: true
            }
        },
        {
            path: '/notifications', component: Notifications,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: true
            }
        },
        {
            path: '/allnotifications', component: AllNotificaionsPage,
            meta: {
                whatsapp: false,
                api: api,
                configUri: configUri,
                allowBack: true,
            }
        },
        {
            path: '/whatsappcoaching', component: WhatsAppCoaching,
            meta: {
                api: api,
                configUri: configUri
            }
        },
        {
            path: '/FinancialFitness', component: FinancialFitnessLandingPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/CustomerTagSpend', component: SpendByCustomerTagPage,
            meta: {
                api: api,
                configUri: configUri,
                escapeRoute: "<",
                //backgroundImage: require('@/assets/bg/bg.png'),
                //backgroundColor: 'white',
            }
        },
        {
            path: '/FinancialFitnessResults', component: FinancialFitnessResultsPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "You"
            }
        },
        {
            path: '/FinancialFitnessHistory', component: FinancialFitnessHistoryPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "You"
            }
        },
        {
            path: '/FinancialFitnessHistory/:id', component: FinancialFitnessHistoryPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "You"
            }
        },
        {
            path: '/Personalisation', component: PersonalisationLandingPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                allowBack: false
            }
        },
        {
            path: '/PersonalisationFinish', component: PersonalisationFinishPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: '#332847',
                allowBack: false
            }
        },
        {
            path: '/FinancesFinish', component: FinancesFinishPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                allowBack: false
            }
        },
        {
            path: '/moneyhublink', component: MoneyHubLink,
            meta: {
                api: api,
                configUri: configUri
            }
        },
        {
            path: '/moneyhubcb/:code', component: MoneyHubCallback,
            meta: {
                api: api,
                configUri: configUri
            }
        },
        {
            path: '/you', component: YouPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                showSettings: true,
                showNotifications: true,
                menuItem: 'you',
                // aiChat: "I'd like to talk about the money guided app in the 'you' screen in the money guided app. The screen shows items that I should draw my attention to. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                allowBack: false,
                bounce: true,
                // backgroundImage: require('@/assets/bg/bg.png'),
            }
        },
        {
            path: '/settings', component: AppSettingsPage,
            meta: {
                api: api,
                configUri: configUri,
                allowBack: true,
                menuItem: 'you',
            }
        },
        {
            path: '/personalinformation', component: PersonalInformationPage,
            meta: {
                api: api,
                configUri: configUri,
                allowBack: true
            }
        },
        {
            path: '/address', component: AddressPage,
            meta: {
                api: api,
                configUri: configUri,
                allowBack: true
            }
        },
        {
            path: '/Benefits', component: BenefitsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'you',
                aiChat: "I'd like to talk about my employer benefits in the 'benefits' screen in the money guided app. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                escapeRoute: "<"
            }
        },
        {
            path: '/BenefitsCalculator', component: BenefitsCalculatorLandingPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/BenefitsCalculatorResults', component: BenefitsCalculatorResultsPage,
            meta: {
                api: api,
                configUri: configUri,
                backgroundColor: 'white',
                escapeRoute: "You"
            }
        },
        {
            path: '/Products/:id', component: ProductPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                backgroundColor: 'white',
                menuItem: 'you',
                escapeRoute: "<",
                allowBack: true
            }
        },
        {
            path: '/Marketplace', component: MarketplacePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'you',
                aiChat: "I'd like to talk the money guided marketplace in the 'marketplace' screen in the money guided app. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                escapeRoute: "<"
            }
        },
        {
            path: '/Calculators', component: CalculatorsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'you',
                aiChat: "I'd like to talk the money guided calculators in the 'Calculators' screen in the money guided app where you can find useful financial calculators. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                escapeRoute: "<"
            }
        },
        {
            path: '/guides', component: GuidesPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'guide',
                allowBack: false,
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/guides/:id', component: GuidePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/guides/sections/:id', component: GuideSectionPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/guides/sections/tasks/:id', component: GuideTaskPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/articles/:id', component: ArticlePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Goals', component: GoalsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'activity',
                aiChat: "I'd like to talk about my savings goals on the 'goals' screen in the money guided app. Savings goals allow me to save for the important things in life. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                allowBack: true,
                //backgroundImage: require('@/assets/bg/bg.png'),
            }
        },
        {
            path: '/Goals/:id', component: GoalPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                escapeRoute: "<"
            }
        },
        {
            path: '/moves', component: MovesPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                aiChat: "I'd like to talk about my moves on the moves screen in the money guided app. I have just clicked on the help button which has shown this chat window. You are the chat agent for this screen. Do not acknowledge my message, only respond as a guide for the screen. Be succinct.",
                escapeRoute: "/"
            }
        },
        {
            path: '/moves/:id', component: MovePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'guide',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/completedmoves', component: CompletedMovesPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                backgroundColor: 'white',
                menuItem: 'activity',
                escapeRoute: "<"
            }
        },
        {
            path: '/enablewhatsapp', component: EnableWhatsApp,
            meta: {
                api: api,
                configUri: configUri,
                escapeRoute: "<",
            }
        },
        {
            path: '/enablenotifications', component: EnableNotificationsPage,
            meta: {
                api: api,
                configUri: configUri,
                allowBack: false
            }
        },
        {
            path: '/Accounts/All/Relink', component: RelinkAccountsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false,
                escapeRoute: "<",
                menuItem: 'money',
            }
        },
        {
            path: '/Accounts/Current/Add', component: AddOfflineBankAccountPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Accounts/Current/Edit/:id', component: AddOfflineBankAccountPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/SpendingTreemap', component: SpendingTreemapPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'activity',
                allowBack: true,
            }
        },
        {
            path: '/SpendingAnalysis', component: SpendingAnalysisPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'activity',
                allowBack: true,
                aiChat: true,
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/TransactionDetail/:id', component: TransactionDetailPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true,
                aiChat: true,
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/SpendingPlan', component: SpendingPlanPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'activity',
                aiChat: true,
                allowBack: true,
                //backgroundImage: require('@/assets/bg/bg.png'),
            }
        },
        {
            path: '/Login', component: LoginPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundImage: require('@/assets/bg/bg.png'),
                allowBack: false
            }
        },
        {
            path: '/Accounts/:accountType', component: AccountsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                bounce: true
            }
        },
        {
            path: '/Account/:id', component: AccountPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Questionnaire/:id', component: QuestionnairePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false,
                menuItem: 'money',
            }
        },
        {
            path: '/Policies/Insurance/Add', component: AddInsurancePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money'
            }
        },
        {
            path: '/Policies/Insurance/Edit/:id', component: AddInsurancePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Policies/:id', component: PolicyPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
            }
        },
        {
            path: '/Investments/Add', component: AddInvestmentPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Investments/Edit/:id', component: AddInvestmentPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Pensions/Add', component: AddPensionPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Pensions/Edit/:id', component: AddPensionPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Pensions/:id', component: AssetPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                assetType: 'pension'
            }
        },
        {
            path: '/Credit/Add', component: AddCreditPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white'
            }
        },
        {
            path: '/Credit/Edit/:id', component: AddCreditPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money'
            }
        },
        {
            path: '/Mortgages/Add', component: AddMortgagePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money'
            }
        },
        {
            path: '/Mortgages/Edit/:id', component: AddMortgagePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
            }
        },
        {
            path: '/Mortgages/:id', component: AssetPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                assetType: 'mortgage'
            }
        },
        {
            path: '/Credit/:id', component: AssetPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                assetType: 'credit'
            }
        },
        {
            path: '/Investments/:id', component: AssetPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                assetType: 'investment'
            }
        },
        {
            path: '/Vouchers', component: VouchersShopPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                backgroundColor: 'white',
                allowBack: true,
            }
        },
        {
            path: '/VoucherCategories', component: VoucherCategories,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true
            }
        },
        {
            path: '/ShopVouchers', component: ShopVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                showVoucherIcon: true,
                showFavoritesIcon: true,
                allowBack: true
            }
        },
        {
            path: '/MyVouchers/Archived/Merchants', component: MyArchivedVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                backgroundColor: 'white',
                bounce: true
            }
        },
        {
            path: '/RecommendedVouchers', component: RecommendedVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                backgroundColor: 'white',
                allowBack: true
            }
        },
        {
            path: '/FeaturedVouchers', component: FeaturedVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true
            }
        },
        {
            path: '/BoostedVouchers', component: BoostedVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true
            }
        },
        {
            path: '/FavoriteVouchers', component: FavoriteVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true
            }
        },
        {
            path: '/Achievements', component: AchievementsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'you',
                allowBack: true
            }
        },
        {
            path: '/Points', component: AchievementsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'you',
                allowBack: true
            }
        },
        {
            path: '/TopSavingsVouchers', component: TopSavingsVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                backgroundColor: 'white',
                allowBack: true
            }
        },
        {
            path: '/BiggestDiscountsVouchers', component: BiggestDiscountsVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                backgroundColor: 'white',
                allowBack: true
            }
        },
        {
            path: '/Vouchers/Search', component: VouchersSearchPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                escapeRoute: "Vouchers"
            }
        },
        {
            path: '/Wallet', component: WalletPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                overrideBack: '/',
                addButton: true,
            }
        },
        {
            path: '/MyVouchers/Merchants', component: MyVouchersByMerchantPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                addButton: true,
                overrideBack: '/money',
                bounce: true
            }
        },
        {
            path: '/SavedToSpend', component: SavedToSpendPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                bounce: true,
                allowBack: true,
            }
        },
        {
            path: '/mymgm', component: MyMGMPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                showSettings: false,
                showNotifications: false,
                allowBack: true,
                bounce: true,
            }
        },
        {
            path: '/Redeem', component: RedeemMGMPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false,
                backgroundColor: 'white'
            }
        },
        {
            path: '/MyVouchers/Merchants/:id', component: MyVouchersForMerchantPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/Vouchers/:id', component: VoucherCheckoutPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                stripeKey: stripeKey,
                allowBack: false
            }
        },
        {
            path: '/Vouchers/Amount/:id', component: VoucherAmountPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                stripeKey: stripeKey,
                allowBack: true
            }
        },
        {
            path: '/VoucherCart', component: VoucherCartPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                stripeKey: stripeKey,
                allowBack: true
            }
        },
        {
            path: '/PaymentComplete', component: PaymentCompletePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                allowBack: false
            }
        },
        {
            path: '/UncategorisedTransactions', component: UncategorisedTransactionsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'activity',
                aiChat: true,
                allowBack: true,
                backgroundColor: 'white'
            }
        },
        {
            path: '/TransactionBulk', component: TransactionBulkPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'activity',
                aiChat: false,
                allowBack: true
            }
        },
        {
            path: '/RecurringPayments', component: RecurringPaymentsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                escapeRoute: "<",
                aiExamples: ['Ask your assistant…', 'How will inflation affect me?', 'How do I avoid bank fees?', 'How can I reduce debts?']
            }
        },
        {
            path: '/PersonalNews', component: PersonalNewsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/Test', component: TestPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                backgroundColor: 'white'
            }
        },
        {
            path: '/story/:id', component: StoryPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: true,
                escapeRoute: "<"
            }
        },
        {
            path: '/desktop',
            component: Desktop,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false
            },
            children: [
                {
                    path: 'chat',
                    component: ChatPage,
                    meta: { api: api, configUri: configUri }
                },
                {
                    path: 'shopvouchers',
                    component: DesktopShopVouchersPage,
                    meta: { api: api, configUri: configUri }
                },
                {
                    path: 'money',
                    component: DesktopTransactionsPage,
                    meta: { api: api, configUri: configUri }
                },
                {
                    path: 'analysis',
                    component: DesktopSpendingAnalysisPage,
                    meta: { api: api, configUri: configUri }
                },
                {
                    path: 'spendingplan',
                    component: DesktopSpendingPlanPage,
                    meta: { api: api, configUri: configUri }
                },
                {
                    path: 'documents',
                    component: DesktopDocumentsPage,
                    meta: { api: api, configUri: configUri }
                }
            ]
        },
        {
            path: '/TestLoadIniit', component: LoadTestPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                backgroundColor: 'white'
            }
        },
        {
            path: '/Documents/Unprocessed',
            component: UnprocessedDocumentsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                backgroundColor: 'white',
                escapeRoute: "<"
            }
        },
        {
            path: '/Documents',
            component: DocumentsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true,
                showWhatsappIcon: true,
            }
        },
        {
            path: '/AllDocuments',
            component: AllDocumentsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true
            }
        },
        {
            path: '/Documents/:id',
            component: DocumentPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true,
            }
        },
        {
            path: '/Documents/:id/view',
            component: DocumentViewPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true,
            }
        },
        {
            path: '/Payslips',
            component: PayslipsPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: true,
                menuItem: 'money',
                allowBack: true,
            }
        },
        {
            path: '/BuyWithConfidence',
            component: BuyWithConfidencePage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                backgroundColor: 'white',
                allowBack: true,
            }
        },
        {
            path: '/TrackYourSpend',
            component: TrackYourSpendPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                backgroundColor: 'white',
                allowBack: true,
            }
        },
        {
            path: '/HowItWorksVouchers',
            component: HowItWorksVouchersPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: true,
            }
        },
        {
            path: '/ChristmasQuizCompleteCorrect/:id',
            component: ChristmasQuizCompleteCorrectPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false,
            }
        },
        {
            path: '/ChristmasQuizCompleteWrong/:id',
            component: ChristmasQuizCompleteWrongPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                allowBack: false,
            }
        },
        {
            path: '/LitmusTestPage',
            component: LitmusTestPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true,
                backgroundColor: '#1c1c1cff'
            }
        },
        {
            path: '/Leaderboard',
            component: AchievementsLeaderBoardPage,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                menuItem: 'money',
                allowBack: true,
                backgroundColor: '#1c1c1cff'
            }
        },
        {
            path: '/admin',
            component: Admin,
            meta: {
                api: api,
                configUri: configUri,
                bottomMenu: false,
                backgroundColor: 'var(--background-color-main)',
                allowBack: true,
                requiresAdmin: true
            },
            children: [
                {
                    path: '',
                    component: AdminLandingPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Money Guided Admin Home'
                    }
                },
                {
                    path: 'factoids',
                    component: FactoidsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Factoids Management'
                    }
                },
                {
                    path: 'employers',
                    component: EmployersPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Employers Management'
                    }
                },
                {
                    path: 'merchants',
                    component: MerchantsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Merchants Management'
                    }
                },
                {
                    path: 'moves',
                    component: AdminMovesPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Moves'
                    }
                },
                {
                    path: 'lists',
                    component: ListsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Lists Management'
                    }
                },
                {
                    path: 'customers',
                    component: CustomersPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Customers Management'
                    }
                },
                {
                    path: 'customer-uploads',
                    component: CustomerUploadsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Customer Uploads'
                    }
                },
                {
                    path: 'cdn-upload',
                    component: CDNUploadPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'CDN Upload'
                    }
                },
                {
                    path: 'vouchers',
                    component: VouchersPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Vouchers Management'
                    }
                },
                {
                    path: 'categories',
                    component: CategoriesPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Categories Management'
                    }
                },
                {
                    path: 'guides',
                    component: GuideAdminPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Guide Management'
                    }
                },
                {
                    path: 'quizzes',
                    component: QuizzesPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Quizzes Management'
                    }
                },
                {
                    path: 'walkthroughs',
                    component: WalkthroughAdminPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Walkthrough Management'
                    }
                },
                {
                    path: 'ai-chat-settings',
                    component: AIChatSettingsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'AI Chat Settings'
                    }
                },
                {
                    path: 'cache',
                    component: CachePage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Cache Management'
                    }
                },
                {
                    path: 'system-status',
                    component: SystemStatusPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'System Status'
                    }
                },
                {
                    path: 'products',
                    component: ProductsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Marketplace Products'
                    }
                },
                {
                    path: 'git-history',
                    component: GitHistoryPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Git History'
                    }
                },
                {
                    path: 'ai-chat-messages',
                    component: AIChatMessagesPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'AI Chat Messages'
                    }
                },
                {
                    path: 'referrals',
                    component: ReferralsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Referrals'
                    }
                },
                {
                    path: 'discount-rate-actions',
                    component: QueuedDiscountActionsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Queued Discount Rate Actions'
                    }
                },
                {
                    path: 'referrals/visualise',
                    component: ReferralsVisualisePage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Referrals Visualisation'
                    }
                },
                {
                    path: 'faqs',
                    component: FaqPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'FAQs Management'
                    }
                },
                {
                    path: 'policy-sections',
                    component: PolicySectionsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Policy Sections'
                    }
                },
                {
                    path: 'brand-logo-overrides',
                    component: BrandLogoOverridesPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Brand Logo Overrides'
                    }
                },
                {
                    path: 'transaction-classifications',
                    component: TransactionClassificationsPage,
                    meta: {
                        requiresAdmin: true,
                        title: 'Transaction Classifications'
                    }
                }
            ]
        }
    ]
});
const navBarRoutes = ['/', '/money', '/guides', '/activity', '/you'];
// Add router navigation guard for admin routes
router.beforeEach((to, from, next) => {
    if (to.path !== '/Login')
        useSystemStatus().fetchSystemStatus();
    if (navBarRoutes.includes(to.path) && to.path !== from.path) {
        spendingFilter.value = 'all';
        spendingPeriod.value = 'month';
        spendingAccount.value = 'all';
        spendingSubCategory.value = '';
        spendingSubCategoryColour.value = '';
        spendingMerchant.value = '';
        spendingDateSelection.value = null;
    }
    if (to.meta.requiresAdmin) {
        // Check if user has admin role
        if (checkIsAdmin(VueCookies)) {
            next();
        }
        else if (VueCookies.get('user') && VueCookies.get('pass')) {
            // Token expired but credentials exist — allow through, useAuth will re-authenticate
            next();
        }
        else {
            // No token and no credentials — redirect to login with return path
            next({ path: '/Login', query: { landingpage: to.path } });
        }
    }
    else {
        next();
    }
});
export default router;
